import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './footer.css';


import {
  faFacebookF,
  faHouzz,
  faInstagram,
  faLinkedinIn,
  faPinterestP,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { faChevronDown as faDown, faChevronUp as faUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showWhyCallistus, setShowWhyCallistus] = useState(false);
  const [showUpdates, setShowUpdates] = useState(false);
  const [showResources, setShowResources] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [formStatus, setFormStatus] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const formRef = useRef();

  const SubmitEmail = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/send-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: formRef.current[0].value
        })
      });

      const result = await response.json();
      if (result.success) {
        setFormSuccess(true);
        setFormStatus(true);
        setTimeout(() => setFormStatus(false), 5000);
        formRef.current.reset();
      } else {
        setFormSuccess(false);
        setFormStatus(true);
        setTimeout(() => setFormStatus(false), 5000);
      }

    } catch (error) {
      console.error(error);
      setFormSuccess(false);
      setFormStatus(true);
      setTimeout(() => setFormStatus(false), 5000);
    }
  }

  return (
    <>
      {/* TODO: confirm final contact number for the chat/call icons — using UAE number for now */}
      <a href="tel:+971581866854" className="WP-chat-icon2" target="_blank" rel="noopener noreferrer">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M14.05 6C15.0268 6.19057 15.9244 6.66826 16.6281 7.37194C17.3318 8.07561 17.8095 8.97326 18 9.95M14.05 2C16.0793 2.22544 17.9716 3.13417 19.4163 4.57701C20.8609 6.01984 21.7721 7.91101 22 9.94M18.5 21C9.93959 21 3 14.0604 3 5.5C3 5.11378 3.01413 4.73086 3.04189 4.35173C3.07375 3.91662 3.08968 3.69907 3.2037 3.50103C3.29814 3.33701 3.4655 3.18146 3.63598 3.09925C3.84181 3 4.08188 3 4.56201 3H7.37932C7.78308 3 7.98496 3 8.15802 3.06645C8.31089 3.12515 8.44701 3.22049 8.55442 3.3441C8.67601 3.48403 8.745 3.67376 8.88299 4.05321L10.0491 7.26005C10.2096 7.70153 10.2899 7.92227 10.2763 8.1317C10.2643 8.31637 10.2012 8.49408 10.0942 8.64506C9.97286 8.81628 9.77145 8.93713 9.36863 9.17882L8 10C9.2019 12.6489 11.3501 14.7999 14 16L14.8212 14.6314C15.0629 14.2285 15.1837 14.0271 15.3549 13.9058C15.5059 13.7988 15.6836 13.7357 15.8683 13.7237C16.0777 13.7101 16.2985 13.7904 16.74 13.9509L19.9468 15.117C20.3262 15.255 20.516 15.324 20.6559 15.4456C20.7795 15.553 20.8749 15.6891 20.9335 15.842C21 16.015 21 16.2169 21 16.6207V19.438C21 19.9181 21 20.1582 20.9007 20.364C20.8185 20.5345 20.663 20.7019 20.499 20.7963C20.3009 20.9103 20.0834 20.9262 19.6483 20.9581C19.2691 20.9859 18.8862 21 18.5 21Z" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
      </a>
      <a target="_blank" href="https://wa.me/919574313456/?text=Hi" className="WP-chat-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#fff" d="M3.516 3.516c4.686-4.686 12.284-4.686 16.97 0s4.686 12.283 0 16.97a12 12 0 0 1-13.754 2.299l-5.814.735a.392.392 0 0 1-.438-.44l.748-5.788A12 12 0 0 1 3.517 3.517zm3.61 17.043.3.158a9.85 9.85 0 0 0 11.534-1.758c3.843-3.843 3.843-10.074 0-13.918s-10.075-3.843-13.918 0a9.85 9.85 0 0 0-1.747 11.554l.16.303-.51 3.942a.196.196 0 0 0 .219.22zm6.534-7.003-.933 1.164a9.84 9.84 0 0 1-3.497-3.495l1.166-.933a.79.79 0 0 0 .23-.94L9.561 6.96a.79.79 0 0 0-.924-.445l-2.023.524a.797.797 0 0 0-.588.88 11.754 11.754 0 0 0 10.005 10.005.797.797 0 0 0 .88-.587l.525-2.023a.79.79 0 0 0-.445-.923L14.6 13.327a.79.79 0 0 0-.94.23z" /></svg>
      </a>
      <footer className="footer">
        <div className="footer-container">
          {isMobile ? (
            <>
              <div className="footer-dropdown footer-dropdown-id1">
                <div
                  className="footer-dropdown-title"
                  onClick={() => setShowWhyCallistus(!showWhyCallistus)}
                >
                  WHY CALLISTUS?
                  <FontAwesomeIcon icon={showWhyCallistus ? faUp : faDown} className="dropdown-icon" />
                </div>
                <div className={`dropdown-content ${showWhyCallistus ? 'show' : ''}`}>
                  <ul>
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/light-control-privacy">Light Control & Privacy</Link>
                    </li>
                    <li>
                      <Link to="/innovation">Innovation</Link>
                    </li>
                    <li>
                      <Link to="/energy-efficiency">Energy Efficiency</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="footer-dropdown footer-dropdown-id2">
                <div
                  className="footer-dropdown-title"
                  onClick={() => setShowUpdates(!showUpdates)}
                >
                  UPDATES
                  <FontAwesomeIcon icon={showUpdates ? faUp : faDown} className="dropdown-icon" />
                </div>
                <div className={`dropdown-content ${showUpdates ? 'show' : ''}`}>
                  <ul>
                    <li>
                      <Link to="/news">News</Link>
                    </li>
                    <li>
                      <Link to="/blogs">Blog</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="footer-dropdown footer-dropdown-id3">
                <div
                  className="footer-dropdown-title"
                  onClick={() => setShowResources(!showResources)}
                >
                  RESOURCES
                  <FontAwesomeIcon icon={showResources ? faUp : faDown} className="dropdown-icon" />
                </div>
                <div className={`dropdown-content ${showResources ? 'show' : ''}`}>
                  <ul>
                    <li>
                      <Link to="/frequently-asked-questions">FAQs</Link>
                    </li>
                    <li>
                      <Link to="/special-solutions">Special Solutions</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/terms-conditions">Terms & Conditions</Link>
                    </li>
                    <li>
                      <Link to="/operating-systems">Operating Systems</Link>
                    </li>
                    <li>
                      <Link to="/fabric-shade">Fabric Shade</Link>
                    </li>
                    <li>
                      <Link to="/dealer-login">Dealer Login</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="footer-dropdown footer-dropdown-id4">
                <div
                  className="footer-dropdown-title"
                  onClick={() => setShowContact(!showContact)}
                >
                  CONTACT US
                  <FontAwesomeIcon icon={showContact ? faUp : faDown} className="dropdown-icon" />
                </div>
                <div className={`dropdown-content ${showContact ? 'show' : ''}`}>
                  <p><strong>UK :</strong><a href="tel:+44 772 361 9926"> +44 772 361 9926</a></p>
                  <p><strong>UAE :</strong><a href="tel:+971 58 186 6854"> +971 58 186 6854</a></p>                
                  <p><strong>Email :</strong><a href="mailto:sales@callistusblinds.com"> sales@callistusblinds.com</a></p>
                  <p><Link to="/trade">Trade Inquires</Link></p>
                  <p><Link to="/contact">Connect to Our Consultant</Link></p>
                </div>
              </div>

              <div className="connect-section">
                <h3>CONNECT</h3>
                <div className="social-icons">
                  <a target='__blank' rel="noopener noreferrer" href="https://facebook.com/Callistuswindowfashions"><FontAwesomeIcon icon={faFacebookF} /></a>
                  <a target='__blank' rel="noopener noreferrer" href="https://www.instagram.com/callistusblindsmiddleeast/"><FontAwesomeIcon icon={faInstagram} /></a>
                  <a target='__blank' rel="noopener noreferrer" href="https://www.youtube.com/@callistusblinds5547"><FontAwesomeIcon icon={faYoutube} /></a>
                  <a target='__blank' rel="noopener noreferrer" href="https://x.com/CallistusBlinds"><FontAwesomeIcon icon={faTwitter} /></a>
                  <a target='__blank' rel="noopener noreferrer" href="https://www.houzz.in/professionals/window-treatments/callistus-blinds-middle-east-fzc-pfvwin-pf~1865750840"><FontAwesomeIcon icon={faHouzz} /></a>
                  <a target='__blank' rel="noopener noreferrer" href="https://in.pinterest.com/callistusblinds"><FontAwesomeIcon icon={faPinterestP} /></a>
                  <a target='__blank' rel="noopener noreferrer" href="https://in.linkedin.com/company/callistus-blinds"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="footer-column">
                <h3>WHY CALLISTUS?</h3>
                <ul>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/light-control-privacy">Light Control & Privacy</Link>
                  </li>
                  <li>
                    <Link to="/innovation">Innovation</Link>
                  </li>
                  <li>
                    <Link to="/energy-efficiency">Energy Efficiency</Link>
                  </li>
                </ul>

                <h3 className="SubCol">UPDATES</h3>
                <ul>
                  <li>
                    <Link to="/news">News</Link>
                  </li>
                  <li>
                    <Link to="/blogs">Blog</Link>
                  </li>
                </ul>
              </div>

              <div className="footer-column">
                <h3>RESOURCES</h3>
                <ul>
                  <li>
                    <Link to="/frequently-asked-questions">FAQs</Link>
                  </li>
                  <li>
                    <Link to="/special-solutions">Special Solutions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-conditions">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/operating-systems">Operating Systems</Link>
                  </li>
                  <li>
                    <Link to="/fabric-shade">Fabric Shade</Link>
                  </li>
                  <li>
                    <Link to="/dealer-login">Dealer Login</Link>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <h3>CONTACT US</h3>
                <p><strong>UK :</strong><a href="tel:+44 772 361 9926"> +44 772 361 9926</a></p>   
                <p><strong>UAE :</strong><a href="tel:+971 58 186 6854"> +971 58 186 6854</a></p>                          
                <p><strong>Email :</strong><a href="mailto:sales@callistusblinds.com"> sales@callistusblinds.com</a></p>
                <p><Link to="/trade">Trade Inquires</Link></p>
                <p><Link to="/contact">Connect to Our Consultant</Link></p>
                <h3 className="connect-sec">CONNECT</h3>
                <div className="social-icons">
                  <a target='__blank' rel="noopener noreferrer" href="https://facebook.com/Callistuswindowfashions"><FontAwesomeIcon icon={faFacebookF} /></a>
                  <a target='__blank' rel="noopener noreferrer" href="https://www.instagram.com/callistusblindsmiddleeast/"><FontAwesomeIcon icon={faInstagram} /></a>
                  <a target='__blank' rel="noopener noreferrer" href="https://www.youtube.com/@callistusblinds5547"><FontAwesomeIcon icon={faYoutube} /></a>
                  <a target='__blank' rel="noopener noreferrer" href="https://x.com/CallistusBlinds"><FontAwesomeIcon icon={faTwitter} /></a>
                  <a target='__blank' rel="noopener noreferrer" href="https://www.houzz.in/professionals/window-treatments/callistus-blinds-middle-east-fzc-pfvwin-pf~1865750840"><FontAwesomeIcon icon={faHouzz} /></a>
                  <a target='__blank' rel="noopener noreferrer" href="https://in.pinterest.com/callistusblinds"><FontAwesomeIcon icon={faPinterestP} /></a>
                  <a target='__blank' rel="noopener noreferrer" href="https://in.linkedin.com/company/callistus-blinds"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                </div>
              </div>
            </>
          )}

          <div className="footer-column footer-col4">
            <h3>SIGN UP FOR UPDATES, TIPS AND OFFERS</h3>
            <p>Get inspired with design information and promotions.</p>
            <form ref={formRef} onSubmit={SubmitEmail}>
              <label className="email-label">EMAIL <span className="required-star">*</span></label>
              <input type="email" placeholder="" required />
              <div className="form-notify">
                {formStatus && formSuccess && (
                  <p className="notify-text success">Your form has been submitted successfully!</p>
                )}
                {formStatus && !formSuccess && (
                  <p className="notify-text error">There was an error submitting your form. Please try again.</p>
                )}
              </div>
              <button type='submit'>Submit</button>
            </form>
          </div>
        </div>

        <div className="footer-bottom footer-bottom-sec">
          <Link to="/" className="footer-text-logo">
            <img src="/Assets/Logo/logo-transparent.png" alt="Callistus Window Fashions" className="footer-brand-logo" />
          </Link>
          <p style={{ width: '100%', textAlign: 'center', margin: '10px 0 0 0', fontSize: '16px' }}>© 2026 Callistus Blinds. All Rights Reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;